import { Button } from "@headlessui/react";
import { CSSProperties } from "react";

export const BorderedButton = ({
  children,
  className,
  onClick,
  otherProps,
  disabled,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: Function;
  otherProps?: any;
  style?: CSSProperties;
  disabled?: boolean;
}) => (
  <>
    <Button
      className={`flex flex-1 items-center py-2 px-8 bg-white text-blue-700 rounded-[8px] border-[1px] border-blue-700 data-[hover]:brightness-125 data-[active]:brightness-125 ${className}`}
      onClick={onClick}
      style={style}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </Button>
  </>
);
